import { ICreateJobForm } from '@/Models'
import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const bolReq = 'Field must be a boolean'
export const reqField = 'Field is required'

export const createJobStepOneSchema = yup.object().shape({
  department: yup.string().required(reqField).typeError(strReq),
  jobTitle: yup.string().required(reqField).typeError(strReq),
  employmentType: yup.string().required(reqField),
  workArrangement: yup.string().required(reqField),
  location: yup.string().required(reqField).typeError(strReq),
  numberOfOpenings: yup.string().optional(),
  hiringManager: yup.string().required(reqField).typeError(strReq),
  recruiter: yup.string().required(reqField).typeError(strReq),
})

const reasons = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

export const CreateJobStepOneComp = (props: { data: any[] }) => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<ICreateJobForm>()

  const returnOptions = ['ID card', 'Work tool', 'Credit card', 'Documents', 'Other']

  return (
    <div className='form-ste deselect'>
      <h4 className='label-step-two text-start pb-3'>Job Information</h4>

      {/* row 1 */}
      <div className='form-group row justify-content-center'>
        <div className='mb-3 text-start col-md-6'>
          <label>Job Title</label>
          <input type='text' className='form-control' {...register('jobTitle')} />
          {errors.jobTitle && <p className='text-danger error-msg'>{errors.jobTitle.message}</p>}
        </div>

        <div className='text-start col-md-6'>
          <label>Department</label>
          {/* <select
            className='form-control input-name'
            {...register('department')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            {props.data.map((ctr, index) => (
              <option key={index} value={`${ctr.firstName} ${ctr.lastName}`}>
                {ctr.firstName} {ctr.lastName}
              </option>
            ))}
          </select> */}
          <select className='form-control input-name' {...register('department')} defaultValue=''>
            <option value='' disabled>
              Select option
            </option>
            <option>Finance Department</option>
            <option>Legal Department</option>
            <option>Corporate Communications Department</option>
            <option>Sales/Marketing Department</option>
            <option>Product Operations Department</option>
            <option>Product Engineering Department</option>
            <option>Human Resources Department</option>
          </select>{' '}
          {errors.department && <p className='text-danger'>{errors.department.message}</p>}
        </div>
      </div>

      {/* Row 2*/}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6'>
          <label>Employment Type</label>
          <select
            className='form-control input-name'
            {...register('employmentType')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            <option value='Full-time'>Full-Time</option>
            <option value='Part-time'>Part-Time</option>
            <option value='Contract'>Contract</option>
            <option value='Internship'>Internship</option>
            <option value='Temporary'>Temporary</option>
            <option value='Other'>Other</option>
          </select>{' '}
          {errors.employmentType && (
            <p className='text-danger error-msg'>{errors.employmentType.message}</p>
          )}
        </div>

        <div className='text-start col-md-6'>
          <label>Work Arrangement</label>
          <select
            className='form-control input-name'
            {...register('workArrangement')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            <option value='lagos'>Lagos</option>
            <option value='hybrid'>Hybrid</option>
            <option value='remote'>Remote</option>
          </select>{' '}
          {errors.workArrangement && (
            <p className='text-danger error-msg'>{errors.workArrangement.message}</p>
          )}
        </div>
      </div>

      {/* row 3 */}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6'>
          <label>Location</label>
          <input type='text' className='form-control' {...register('location')} />
          {errors.location && <p className='text-danger error-msg'>{errors.location.message}</p>}
        </div>
        <div className='text-start col-md-6'>
          <label>Number of Openings</label>
          <input type='text' className='form-control' {...register('numberOfOpenings')} />
          {errors.numberOfOpenings && (
            <p className='text-danger'>{errors.numberOfOpenings.message}</p>
          )}
        </div>
      </div>

      {/* row 4  */}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6'>
          <label>Hiring Manager</label>
          <select
            className='form-control input-name'
            {...register('hiringManager')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            {props.data.map((ctr, index) => (
              <option key={index} value={`${ctr.firstName} ${ctr.lastName}`}>
                {ctr.firstName} {ctr.lastName}
              </option>
            ))}
          </select>
          {/* <select
            className='form-control input-name'
            {...register('hiringManager')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            <option value='emmie'>emmie</option>
            <option value='ayo'>ayo</option>
          </select> */}
          {errors.hiringManager && (
            <p className='text-danger error-msg'>{errors.hiringManager.message}</p>
          )}
        </div>

        <div className='text-start col-md-6'>
          <label>Recruiter / HR Owner</label>
          <select className='form-control input-name' {...register('recruiter')} defaultValue=''>
            <option value='' disabled>
              Select option
            </option>
            {props.data.map((ctr, index) => (
              <option key={index} value={`${ctr.firstName} ${ctr.lastName}`}>
                {ctr.firstName} {ctr.lastName}
              </option>
            ))}
          </select>
          {/* <select className='form-control input-name' {...register('recruiter')} defaultValue=''>
            <option value='' disabled>
              Select option
            </option>
            <option value='nengi'>nengi</option>
            <option value='anne'>anne</option>
          </select> */}
          {errors.recruiter && <p className='text-danger'>{errors.recruiter.message}</p>}
        </div>
      </div>
      {/* row 4  */}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6'>
          <label>Application Deadline</label>
          <input type='date' className='form-control' {...register('applicationDeadline')} />
          {errors.hiringManager && <p className='text-danger'>{errors.hiringManager.message}</p>}
        </div>

        <div className='text-start col-md-6 invisible'>
          <label>Recruiter / HR Owner</label>
          {/* <select
            className='form-control input-name'
            {...register('recruiter')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            {props.data.map((ctr, index) => (
              <option key={index} value={`${ctr.firstName} ${ctr.lastName}`}>
                {ctr.firstName} {ctr.lastName}
              </option>
            ))}
          </select> */}

          <select
            className='form-control input-name'
            // {...register('recruiter')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            <option value='dff'>dff</option>
            <option value='dff'>dff</option>
          </select>
          {/* {errors.recruiter && <p className='text-danger'>{errors.recruiter.message}</p>} */}
        </div>
      </div>
    </div>
  )
}
